module.exports = __webpack_public_path__ + "static/img/loading.8820c173.svg";